// recovery-ai-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A IA está lendo a campanha…": "La IA está leyendo la campaña…",
    "Começo da campanha": "Inicio de la campaña",
    "Indo bem": "Va bien",
    "Não está funcionando": "No está funcionando",
    "Pede atenção": "Requiere atención",
};

export default catalogo;
